import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  FzGoogleTagManagerService,
  SubscribeApiService,
} from '@fantaz/shared/data-access/api';
import { GAEventKeys } from '@fantaz/shared/data-access/models';
import {
  SubscribeInfo,
  SubscribeParams,
} from '@fantaz/shared/data-access/models/src/lib/subscribe';
import { EventSchedule } from '@fantaz/shared/data-access/models/src/lib/tournament';
import { CurrentUser } from '@fantaz/shared/data-access/models/src/lib/user';
import {
  LeaderState,
  loadCasualTournamentDetailsSubscribed,
} from '@fantaz/tournaments/data-access';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { SubscribeDialogComponent } from '../subscribe-dialog/subscribe-dialog.component';

@Component({
  selector: 'fz-subscribe-button',
  templateUrl: './subscribe-button.component.html',
  styleUrls: ['./subscribe-button.component.scss'],
})
export class SubscribeButtonComponent implements OnInit {
  @Input()
  eventSchedule: EventSchedule | null | undefined;
  @Input()
  eventPrototypeUuid: string | null | undefined;
  @Input()
  currentUser: CurrentUser | null | undefined;

  @Input()
  responsive: boolean;

  subscribeDialogInfo: SubscribeInfo = {
    name: '',
    email: '',
  };
  subscribeParams: SubscribeParams;
  loading: boolean;

  constructor(
    private dialog: MatDialog,
    private store: Store<LeaderState>,
    private subscribeApiService: SubscribeApiService,
    private gtmService: FzGoogleTagManagerService,
  ) {}

  ngOnInit(): void {
    this.subscribeParams = {
      eventPrototypeUuid: this.eventPrototypeUuid as string,
      eventScheduleUuid:
        this.eventSchedule?.uuid ||
        (this.eventSchedule?.eventScheduleUuid as string),
      name: '',
      email: '',
    };
  }

  onSubscribe() {
    console.log(this.currentUser);
    if (!this.currentUser?.user.email) {
      this.openDialog();
    } else {
      this.subscribeParams.name = this.currentUser?.user.username as string;
      this.subscribeParams.email = this.currentUser?.user.email as string;
      if (this.eventSchedule?.subscriptionStatus) {
        this.deleteSubscribeToTournament();
      } else {
        this.callSubscribeEndpoint();
      }
    }
  }

  openDialog() {
    const dialogRef = this.dialog.open(SubscribeDialogComponent, {
      data: this.subscribeDialogInfo,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.subscribeParams.name = result.name;
        this.subscribeParams.email = result.email;
        if (this.eventSchedule?.subscriptionStatus) {
          this.deleteSubscribeToTournament();
        } else {
          this.callSubscribeEndpoint();
        }
      }
    });
  }

  deleteSubscribeToTournament() {
    this.loading = true;
    this.subscribeParams.eventPrototypeUuid = this.eventPrototypeUuid as string;
    this.subscribeParams.eventScheduleUuid =
      this.eventSchedule?.uuid ||
      (this.eventSchedule?.eventScheduleUuid as string);
    this.subscribeApiService
      .deleteSubscribeToTournament(this.subscribeParams)
      .pipe(take(1))
      .subscribe({
        next: (resp) => {
          if (resp.message === 'done') {
            this.triggerChange(false);
          }
          this.loading = false;
          this.gtmService.pushTag({
            event: GAEventKeys.USER_UNSUBSCRIBES_TOURNAMENT,
            user_id: this.currentUser?.user.uuid,
            user_name: this.currentUser?.user.username,
            tournament_id: this.eventPrototypeUuid || '',
            instance_id: this.subscribeParams.eventScheduleUuid || '',
            timestamp: Date.now(),
          });
        },
        error: () => {
          this.loading = false;
        },
      });
  }
  callSubscribeEndpoint() {
    this.loading = true;
    this.subscribeParams.eventPrototypeUuid = this.eventPrototypeUuid as string;
    this.subscribeParams.eventScheduleUuid =
      this.eventSchedule?.uuid ||
      (this.eventSchedule?.eventScheduleUuid as string);

    this.subscribeApiService
      .postSubscribeToTournament(this.subscribeParams)
      .pipe(take(1))
      .subscribe({
        next: (resp) => {
          const status = resp.message === 'done';
          this.triggerChange(status);
          this.loading = false;
          this.gtmService.pushTag({
            event: GAEventKeys.USER_SUBSCRIBES_TOURNAMENT,
            user_id: this.currentUser?.user.uuid,
            user_name: this.currentUser?.user.username,
            tournament_id: this.eventPrototypeUuid || '',
            instance_id: this.subscribeParams.eventScheduleUuid || '',
            timestamp: Date.now(),
          });
        },
        error: () => {
          this.loading = false;
        },
      });
  }

  triggerChange(status: boolean) {
    this.store.dispatch(
      loadCasualTournamentDetailsSubscribed({
        eventScheduleUuid: this.subscribeParams.eventScheduleUuid,
        eventPrototypeUuid: this.subscribeParams.eventPrototypeUuid,
        status,
      }),
    );
  }
}
